import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "state"
}
const _hoisted_2 = {
  key: 1,
  class: "wrap"
}
const _hoisted_3 = { class: "lead-line" }
const _hoisted_4 = { class: "muted" }
const _hoisted_5 = { class: "muted" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = {
  key: 2,
  class: "row"
}
const _hoisted_10 = {
  key: 3,
  class: "agenda"
}
const _hoisted_11 = {
  key: 4,
  class: "muted"
}
const _hoisted_12 = {
  key: 5,
  class: "muted"
}
const _hoisted_13 = {
  key: 6,
  class: "muted"
}
const _hoisted_14 = {
  key: 0,
  class: "banner warn"
}
const _hoisted_15 = { class: "actions" }
const _hoisted_16 = { class: "sub-h" }
const _hoisted_17 = {
  key: 1,
  class: "empty"
}
const _hoisted_18 = { class: "fb-top" }
const _hoisted_19 = { class: "muted" }
const _hoisted_20 = { class: "notes" }
const _hoisted_21 = {
  key: 0,
  class: "next"
}
const _hoisted_22 = {
  key: 1,
  class: "muted"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "field" }
const _hoisted_25 = { class: "field" }
const _hoisted_26 = { class: "field" }
const _hoisted_27 = { class: "field" }
const _hoisted_28 = { class: "field" }
const _hoisted_29 = { class: "field" }
const _hoisted_30 = {
  key: 0,
  class: "hint"
}
const _hoisted_31 = { class: "field" }
const _hoisted_32 = { class: "field" }
const _hoisted_33 = { class: "field" }
const _hoisted_34 = { class: "field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_FormSheet = _resolveComponent("FormSheet")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _ctx.goBack
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.arrowBackOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("Meeting", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _ctx.load
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "page-bg"
      }, {
        default: _withCtx(() => [
          (!_ctx.meeting)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner, { name: "crescent" })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "card",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/sales-leads/' + _ctx.meeting.lead.id)))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_ctx.meeting.lead.company_name) + " ", 1),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.meeting.lead.lead_code) + " ›", 1)
                  ]),
                  _createElementVNode("h2", null, [
                    _createTextVNode(_toDisplayString(_ctx.meeting.meeting_type) + " ", 1),
                    _createElementVNode("span", _hoisted_5, "· " + _toDisplayString(_ctx.meeting.mode), 1)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["status", 'st-' + _ctx.meeting.status.toLowerCase()])
                  }, _toDisplayString(_ctx.meeting.status), 3),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_ion_icon, { icon: _ctx.timeOutline }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.format(_ctx.meeting.scheduled_at)), 1)
                  ]),
                  (_ctx.meeting.location)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_ion_icon, { icon: _ctx.locationOutline }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.meeting.location), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.meeting.attendees_client)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_ion_icon, { icon: _ctx.peopleOutline }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.meeting.attendees_client), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.meeting.attendee_names && _ctx.meeting.attendee_names.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_ion_icon, { icon: _ctx.personAddOutline }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.meeting.attendee_names.join(', ')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.meeting.agenda)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.meeting.agenda), 1))
                    : _createCommentVNode("", true),
                  (_ctx.meeting.status_reason)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Reason: " + _toDisplayString(_ctx.meeting.status_reason), 1))
                    : _createCommentVNode("", true),
                  (_ctx.meeting.rescheduled_from)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Rescheduled from " + _toDisplayString(_ctx.format(_ctx.meeting.rescheduled_from.scheduled_at)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.meeting.held_at)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Held " + _toDisplayString(_ctx.format(_ctx.meeting.held_at)), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.meeting.feedback_overdue)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "This meeting's time has passed. Complete it with feedback, or mark it cancelled / no-show."))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.permissions.can_complete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openFeedback('complete')))
                      }, "Complete + feedback"))
                    : _createCommentVNode("", true),
                  (_ctx.permissions.can_add_feedback)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openFeedback('add')))
                      }, "Add feedback"))
                    : _createCommentVNode("", true),
                  (_ctx.permissions.can_reschedule)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sheet = 'reschedule'))
                      }, "Reschedule"))
                    : _createCommentVNode("", true),
                  (_ctx.permissions.can_cancel)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sheet = 'cancel'))
                      }, "Cancel / No-show"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("h4", _hoisted_16, "Feedback (" + _toDisplayString(_ctx.meeting.feedbacks.length) + ")", 1),
                (!_ctx.meeting.feedbacks.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, "No feedback yet."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meeting.feedbacks, (fb) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: fb.id,
                    class: "fb"
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", {
                        class: "sent",
                        style: _normalizeStyle(_ctx.sentimentStyle(fb.client_sentiment))
                      }, _toDisplayString(fb.client_sentiment), 5),
                      _createElementVNode("b", null, _toDisplayString(fb.outcome), 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.format(fb.created_at)) + " · " + _toDisplayString(fb.logged_by ? fb.logged_by.name : ''), 1),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(fb.feedback), 1),
                    (fb.next_step)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, "→ " + _toDisplayString(fb.next_step), 1))
                      : _createCommentVNode("", true),
                    (fb.next_meeting_at)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Next meeting: " + _toDisplayString(_ctx.format(fb.next_meeting_at)), 1))
                      : _createCommentVNode("", true),
                    (fb.attachment_url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 2,
                          href: fb.attachment_url,
                          target: "_blank",
                          class: "link"
                        }, "View attachment", 8, _hoisted_23))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "hint" }, "Feedback is permanent. To correct something, add a new entry.", -1))
              ])),
          _createVNode(_component_FormSheet, {
            open: _ctx.sheet === 'feedback',
            title: _ctx.feedbackMode === 'complete' ? 'Complete meeting' : 'Add feedback',
            "submit-label": _ctx.feedbackMode === 'complete' ? 'Complete' : 'Add feedback',
            busy: _ctx.busy,
            onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sheet = null)),
            onSubmit: _ctx.submitFeedback
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_24, [
                _cache[20] || (_cache[20] = _createElementVNode("label", null, [
                  _createTextVNode("What happened? "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fbForm.feedback) = $event)),
                  placeholder: "Who attended, what was discussed, the client's reaction"
                }, null, 512), [
                  [_vModelText, _ctx.fbForm.feedback]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[22] || (_cache[22] = _createElementVNode("label", null, [
                  _createTextVNode("Client sentiment "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fbForm.client_sentiment) = $event))
                }, [
                  _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "Select", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta ? _ctx.meta.sentiments : [], (s) => {
                    return (_openBlock(), _createElementBlock("option", { key: s }, _toDisplayString(s), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.fbForm.client_sentiment]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[24] || (_cache[24] = _createElementVNode("label", null, [
                  _createTextVNode("Outcome "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fbForm.outcome) = $event))
                }, [
                  _cache[23] || (_cache[23] = _createElementVNode("option", { value: "" }, "Select", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meta ? _ctx.meta.outcomes : [], (o) => {
                    return (_openBlock(), _createElementBlock("option", { key: o }, _toDisplayString(o), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.fbForm.outcome]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _cache[25] || (_cache[25] = _createElementVNode("label", null, "Next step", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fbForm.next_step) = $event)),
                  maxlength: "255",
                  placeholder: "e.g. Send revised price by Thursday"
                }, null, 512), [
                  [_vModelText, _ctx.fbForm.next_step]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[26] || (_cache[26] = _createElementVNode("label", null, "Next meeting", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.fbForm.next_meeting_at) = $event)),
                  type: "datetime-local"
                }, null, 512), [
                  [_vModelText, _ctx.fbForm.next_meeting_at]
                ]),
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "hint" }, "Setting this books a Follow-up meeting automatically.", -1))
              ]),
              _createElementVNode("div", _hoisted_29, [
                _cache[28] || (_cache[28] = _createElementVNode("label", null, "Attachment", -1)),
                _createElementVNode("input", {
                  type: "file",
                  accept: "image/*,application/pdf",
                  onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onFile && _ctx.onFile(...args)))
                }, null, 32)
              ]),
              (_ctx.feedbackMode === 'complete')
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Your current location is saved with the meeting as proof it took place."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["open", "title", "submit-label", "busy", "onSubmit"]),
          _createVNode(_component_FormSheet, {
            open: _ctx.sheet === 'reschedule',
            title: "Reschedule meeting",
            "submit-label": "Reschedule",
            busy: _ctx.busy,
            onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sheet = null)),
            onSubmit: _ctx.submitReschedule
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_31, [
                _cache[29] || (_cache[29] = _createElementVNode("label", null, [
                  _createTextVNode("New date & time "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rescheduleForm.scheduled_at) = $event)),
                  type: "datetime-local"
                }, null, 512), [
                  [_vModelText, _ctx.rescheduleForm.scheduled_at]
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[30] || (_cache[30] = _createElementVNode("label", null, [
                  _createTextVNode("Reason "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rescheduleForm.reason) = $event)),
                  maxlength: "255",
                  placeholder: "e.g. Client asked to postpone"
                }, null, 512), [
                  [_vModelText, _ctx.rescheduleForm.reason]
                ])
              ])
            ]),
            _: 1
          }, 8, ["open", "busy", "onSubmit"]),
          _createVNode(_component_FormSheet, {
            open: _ctx.sheet === 'cancel',
            title: "Cancel meeting",
            "submit-label": "Save",
            danger: "",
            busy: _ctx.busy,
            onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sheet = null)),
            onSubmit: _ctx.submitCancel
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_33, [
                _cache[32] || (_cache[32] = _createElementVNode("label", null, "Mark as", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.cancelForm.status) = $event))
                }, [...(_cache[31] || (_cache[31] = [
                  _createElementVNode("option", null, "Cancelled", -1),
                  _createElementVNode("option", null, "No-show", -1)
                ]))], 512), [
                  [_vModelSelect, _ctx.cancelForm.status]
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[33] || (_cache[33] = _createElementVNode("label", null, [
                  _createTextVNode("Reason "),
                  _createElementVNode("span", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.cancelForm.reason) = $event)),
                  maxlength: "255"
                }, null, 512), [
                  [_vModelText, _ctx.cancelForm.reason]
                ])
              ])
            ]),
            _: 1
          }, 8, ["open", "busy", "onSubmit"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}